<template>
  <footer class="copyright">
    【免责声明】本公司力求数据的准确性，如有错漏请以上市公司公告原文为准。本公司不因对该资料产生或引起的任何损失承担任何责任。
    大智慧数据中心制作，如有疑问请拨打021-20219988-39108
  </footer>
</template>
<script>
export default{
  name: "declare"
}
</script>